module.exports = __webpack_public_path__ + "img/ucsdmakerspace.5bd23ef5.png";